<script setup lang="ts">
import { NButton, NIcon, NDropdown } from 'naive-ui';
import { Export } from '@vicons/carbon';
import { useWebCutContext, useWebCutPlayer, useWebCutData } from '../../hooks';
import { useT } from '../../hooks/i18n';
import { downloadBlob } from '../../libs/file';

const { download } = useWebCutPlayer();
const { sprites } = useWebCutContext();
const { getData } = useWebCutData();
const t = useT();

const exportOptions = [
    {
        label: '영상 내보내기',
        key: 'video',
    },
    {
        label: '프로젝트 저장하기',
        key: 'json',
    },
];

async function handleSelect(key: string) {
    if (key === 'video') {
        await download();
    } else if (key === 'json') {
        if (typeof window.showSaveFilePicker === 'function') {
            try {
                const fileHandle = await window.showSaveFilePicker({
                    suggestedName: `webcut-project-${Date.now()}.json`,
                    types: [
                        {
                            description: 'WebCut 프로젝트',
                            accept: {
                                'application/json': ['.json']
                            }
                        }
                    ]
                });
                const data = await getData();
                const jsonStr = JSON.stringify(data, null, 2);
                const writable = await fileHandle.createWritable();
                await writable.write(jsonStr);
                await writable.close();
                return;
            } catch (error) {
                if (error instanceof Error && error.name === 'AbortError') {
                    // 사용자가 취소한 경우, 아무것도 하지 않음
                    return;
                }
                console.error('파일 저장 실패:', error);
                // 에러 발생 시에도 fallback으로 가지 않음
                return;
            }
        }
        // Fallback for browsers that don't support showSaveFilePicker
        const data = await getData();
        const jsonStr = JSON.stringify(data, null, 2);
        const blob = new Blob([jsonStr], { type: 'application/json' });
        downloadBlob(blob, `webcut-project-${Date.now()}.json`);
    }
}
</script>

<template>
    <n-dropdown trigger="click" :options="exportOptions" @select="handleSelect" :disabled="sprites.length === 0">
        <n-button v-bind="$attrs" type="primary" size="tiny" :disabled="sprites.length === 0" class="webcut-export-button">
            <template #icon>
                <n-icon><Export /></n-icon>
            </template>
            <slot>{{ t('导出') }}</slot>
        </n-button>
    </n-dropdown>
</template>

<style scoped lang="less">
@import "../../styles/export-button.less";
</style>
